import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-12 pb-16 md:pt-20 md:pb-24 px-4 overflow-hidden" data-id="element-128" data-mp="2hut1rixelgyu">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-129" data-mp="23w38yfhma3ga">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-gold/20 blur-3xl" data-id="element-130" data-mp="28tcwfplg451h"></div>
        <div className="absolute top-1/2 -left-24 w-72 h-72 rounded-full bg-forest/10 blur-3xl" data-id="element-131" data-mp="2wjgznvuq22ry"></div>
      </div>

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-132" data-mp="30k0uutvqiwbg">
        {/* Pre-headline Pattern Interrupt */}
        <div className="inline-flex items-center justify-center px-4 py-2 mb-8 rounded-full bg-red-50 border border-urgency/20 shadow-sm" data-id="element-133" data-mp="2mrta60hq6vt4">
          <span className="text-urgency font-bold text-sm md:text-base tracking-wide flex items-center gap-2" data-id="element-134" data-mp="3fi1jr3y747w3">
            <span className="animate-pulse" data-id="element-135" data-mp="3k9jpe5b5ywne">⚠️</span> ATENCIÓN MUJERES DE MÁS DE
            35 AÑOS:
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-forest leading-tight md:leading-tight mb-6 text-balance" data-id="element-136" data-mp="2bdx2yjc8jdl4">
          "Descubrí Por Qué Tu Vientre Se Hincha Cada Noche Aunque Comas Sano{' '}
          <span className="text-gold-dark" data-id="element-137" data-mp="2ke3bdqt2tndf">
            — Y El Método de 15 Minutos Que Lo Detiene Mientras Duermes"
          </span>
        </h1>

        {/* Sub-headline */}
        <p className="text-lg md:text-xl text-dark/80 italic font-medium max-w-3xl mb-10" data-id="element-138" data-mp="2u4etqidibz3u">
          Sin dietas extremas. Sin pasar hambre. Sin ingredientes raros. Solo
          comida real que tu cuerpo entiende.
        </p>

        {/* Emotional Hook Box */}
        <div className="w-full max-w-2xl bg-white p-6 md:p-8 rounded-2xl shadow-warm border border-gold/20 mb-12 relative" data-id="element-139" data-mp="335mdlvfa0xee">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-forest-dark text-xs font-bold uppercase tracking-wider py-1 px-3 rounded-full" data-id="element-140" data-mp="1drzpx1gmk0gk">
            Importante
          </div>
          <p className="text-base md:text-lg font-medium text-dark leading-relaxed" data-id="element-141" data-mp="38vnywnghhfa0">
            <strong className="text-forest" data-id="element-142" data-mp="3duigjm2psxsj">
              Si te vas a dormir sintiéndote pesada, hinchada y frustrada a
              pesar de "esforzarte"...
            </strong>{' '}
            esta puede ser la página más importante que leerás este año.
          </p>
        </div>

        {/* Product Mockup */}
        <div className="w-full max-w-md mx-auto mb-10 relative group" data-id="element-143" data-mp="3rqcoo2vnzj4l">
          <div className="absolute inset-0 bg-gold/20 blur-2xl rounded-full scale-90 group-hover:scale-100 transition-transform duration-700" data-id="element-144" data-mp="k1la036m6a3"></div>
          <img src="https://cdn.magicpatterns.com/uploads/rdHi3rAEoBrUtDvyQN1xfL/mockup_cenas_antiinf15.png" alt="Cenas Anti-Inflamatorias en 15 Minutos" className="relative z-10 w-full h-auto drop-shadow-2xl animate-[float_6s_ease-in-out_infinite]" data-id="element-145" data-mp="ac7bb49vidmn" />
        </div>

        {/* CTA */}
        <div className="w-full max-w-md mx-auto" data-id="element-146" data-mp="23ueole0j1uqs">
          <CTAButton text="QUIERO DESINFLAMAR MI VIENTRE →" href="#offer-section" variant="primary" data-id="element-147" data-mp="23v7pvzgpvs1j" />
        </div>
      </div>
    </section>;
}